import { defineWidgetSettings } from "@nexus/widget-sdk";

/** What an author sets on the supply chain Sankey. */
export const settings = defineWidgetSettings({
  id: "supply-chain-sankey",
  properties: {
    viewMode: {
      type: "string",
      title: "View",
      description:
        "Simple shows one block per stage; Detailed shows every node, with a legend and a focus.",
      default: "simple",
      oneOf: [
        { const: "simple", title: "Simple" },
        { const: "detailed", title: "Detailed" },
      ],
      "x-ui": { category: "display", order: 10, summary: true },
    },
  },
});
